import '../styles/sidebar.css'
import React from 'react'

export default function Sidebar({
    homeSectionRef,
    projectSectionRef,
    aboutSectionRef,
    contactSectionRef,
    publicationRef,
  }){

    const scrollDown = (ref) => {
        window.scrollTo({
          top: ref.current.offsetTop,
          behavior: "smooth",
        });
      };

    return(
        <div className="sidebar">
            <ul className="sidebar-list">
          <li className="sidebar-options" onClick={() => scrollDown(homeSectionRef)}>Home</li>
          <li className="sidebar-options" onClick={() => scrollDown(aboutSectionRef)}>About Me</li>
          <li className="sidebar-options" onClick={() => scrollDown(projectSectionRef)}>Projects</li>
          <li className="sidebar-options" onClick={() => scrollDown(publicationRef)}>Publications</li>
          <li className="sidebar-options" onClick={() => scrollDown(contactSectionRef)}>Contact</li>
        </ul>
        </div>
    )
}